import { get, del } from 'data/services/apiService';
import { API_URL } from 'data/services/apiConstants';

const CHECK_AUTH_TOKEN_REQUEST = 'CHECK_AUTH_TOKEN_REQUEST';
const CHECK_AUTH_TOKEN_SUCCESS = 'CHECK_AUTH_TOKEN_SUCCESS';
const CHECK_AUTH_TOKEN_ERROR = 'CHECK_AUTH_TOKEN_ERROR';

const UNSUBSCRIBE_BY_TOKEN_REQUEST = 'UNSUBSCRIBE_BY_TOKEN_REQUEST';
const UNSUBSCRIBE_BY_TOKEN_SUCCESS = 'UNSUBSCRIBE_BY_TOKEN_SUCCESS';
const UNSUBSCRIBE_BY_TOKEN_ERROR = 'UNSUBSCRIBE_BY_TOKEN_ERROR';

const initialState = {
	token: null,
	isLoading: false,
	hasError: false,
	error: null,
	unsubSuccess: false,
	unsubError: false,
};

export const checkAuthToken = (token) => (dispatch) => {
	let url = `${API_URL}/api/temporaryAuthTokens/${token}`;
	dispatch(checkTempAuthTokenRequest());
	return get({
		dispatch,
		url,
		onSuccess: (result) => {
			dispatch(checkTempAuthTokenSuccess(result));
		},
		onError: error => dispatch(checkTempAuthTokenError(error)),
	});
};

export const unsubscribeByToken = (token) => (dispatch) => {
	let url = `${API_URL}/api/temporaryAuthTokens/${token}/user/notifications`;
	dispatch(unsubByTokenRequest());
	return del({
		dispatch,
		url,
		onSuccess: (result) => {
			dispatch(unsubByTokenSuccess(result));
		},
		onError: (error) => {
			dispatch(unsubByTokenError(error));
		},
	});
};

export const checkTempAuthTokenRequest = () => ({
	type: CHECK_AUTH_TOKEN_REQUEST,
	payload: {
		token: null,
		isLoading: true,
		hasError: false,
		error: null,
	}
});

export const checkTempAuthTokenSuccess = (token) => ({
	type: CHECK_AUTH_TOKEN_SUCCESS,
	payload: {
		isLoading: false,
		token,
		hasError: false,
		error: null,
	}
});

export const checkTempAuthTokenError = (error) => ({
	type: CHECK_AUTH_TOKEN_ERROR,
	payload: {
		isLoading: false,
		token: null,
		hasError: true,
		error: error,
	}
});

export const unsubByTokenRequest = () => ({
	type: UNSUBSCRIBE_BY_TOKEN_REQUEST,
	payload: {
		isLoading: true,
		unsubSuccess: false,
		unsubError: false,
	}
});

export const unsubByTokenSuccess = (token) => ({
	type: UNSUBSCRIBE_BY_TOKEN_SUCCESS,
	payload: {
		isLoading: false,
		unsubSuccess: true,
		unsubError: false,
	}
});

export const unsubByTokenError = (error) => ({
	type: UNSUBSCRIBE_BY_TOKEN_ERROR,
	payload: {
		isLoading: false,
		unsubSuccess: false,
		unsubError: true,
	}
});

const tempAuthTokenReducer = (state = initialState, action) => {
	switch (action.type) {
		case CHECK_AUTH_TOKEN_REQUEST:
		case CHECK_AUTH_TOKEN_SUCCESS:
		case CHECK_AUTH_TOKEN_ERROR:
		case UNSUBSCRIBE_BY_TOKEN_REQUEST:
		case UNSUBSCRIBE_BY_TOKEN_SUCCESS:
		case UNSUBSCRIBE_BY_TOKEN_ERROR:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default tempAuthTokenReducer;
